import { motion } from "framer-motion";

export const Reveal = ({ children, delay = 0, y = 24, className = "" }) => (
  <motion.div
    className={className}
    initial={{ opacity: 0, y }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once: true, margin: "-80px" }}
    transition={{ duration: 0.7, delay, ease: [0.22, 1, 0.36, 1] }}
  >
    {children}
  </motion.div>
);

export const Overline = ({ children, className = "" }) => (
  <span className={`overline text-gold ${className}`}>{children}</span>
);

export const SectionHeading = ({ overline, title, subtitle, light = false, align = "left", className = "" }) => (
  <div className={`${align === "center" ? "text-center mx-auto max-w-3xl" : "max-w-2xl"} ${className}`}>
    {overline && <Overline>{overline}</Overline>}
    <h2 className={`mt-4 font-serif font-normal text-3xl sm:text-4xl md:text-5xl leading-[1.05] tracking-tight ${light ? "text-ivory" : "text-forest"}`}>
      {title}
    </h2>
    {subtitle && (
      <p className={`mt-5 text-base md:text-lg font-light leading-relaxed ${light ? "text-ivory/75" : "text-navy/70"}`}>
        {subtitle}
      </p>
    )}
  </div>
);
